<script>
  import NumberInput from 'components/NumberInput/NumberInput';
  import CheckboxInput from 'components/CheckboxInput/CheckboxInput';
  import { onMount, onDestroy } from 'svelte';
  import draft from 'stores/Draft';
  import selection from '../../Selection/SelectionStore';
  import * as draftUtil from 'util/DraftUtil';
  import ui from 'stores/UI';
  import { t } from 'precompile-intl-runtime';

  function weftToWarp() {
    draft.update((temp) => {
      for (let i = 0; i < $draft.warpCount; i++) {
        temp.threading[i] = $draft.treadleOrder[i % $draft.treadleOrder.length];
      }
    });
  }

  function warpToWeft() {
    draft.update((temp) => {
      for (let i = 0; i < $draft.weftCount; i++) {
        temp.treadleOrder[i] = $draft.threading[i % $draft.threading.length];
      }
    });
  }

  function flipWarp() {
    draft.update((temp) => {
      for (let i = 0; i < $draft.warpCount; i++) {
        temp.threading[i] = $draft.shaftCount - $draft.threading[i] - 1;
      }
    });
  }

  function flipWeft() {
    draft.update((temp) => {
      for (let i = 0; i < $draft.warpCount; i++) {
        temp.treadleOrder[i] = $draft.treadleCount - $draft.treadleOrder[i] - 1;
      }
    });
  }

  function invertTieup() {
    draft.update((temp) => {
      for (let i = 0; i < $draft.tieup.length; i++) {
        for (let j = 0; j < $draft.tieup[0].length; j++) {
          temp.tieup[i][j] = $draft.tieup[i][j] === 0 ? 1 : 0;
        }
      }
    });
  }
</script>

<button on:click={warpToWeft}>Warp to weft</button>
<button on:click={weftToWarp}>Weft to warp</button>

<button on:click={flipWarp}>Flip warp</button>
<button on:click={flipWeft}>Flip weft</button>

<button on:click={invertTieup}>Invert tieup</button>

<style>
</style>
